import { UserDomain } from '../Auth'
import { Domain, User } from '../Catalogs'
import { GroupEntity } from '../catalogs/Groups'
import { NOT_ALLOWED_VIEW } from '@/types/viewAccess/AccessFailed'

class NotificationRequest {
  subject: string
  message: string
  users?: number[]
  groups?: number[]
  subGroups?: boolean
  domain?: number

  constructor () {
    this.subject = 'Generic subject.'
    this.message = 'Generic message.'
  }

  isGoingToUsers (): boolean {
    return this.users !== undefined && this.users.length >= 1 && this.groups?.length === 0 && this.domain === undefined
  }

  isGoingToGroups (): boolean {
    return this.groups !== undefined && this.groups.length >= 1 && this.users?.length === 0 && this.domain === undefined
  }

  isGoingToDomain (): boolean {
    return this.groups !== undefined && this.groups.length >= 1 && this.users?.length === 0 && this.domain === undefined
  }
}

interface NotificationResponse {
  successCount: number
  failureCount: number
}

enum NOTIFICATION_TARGET {
  USERS = 'user',
  GROUPS = 'groups',
  DOMAIN = 'domain'
}

interface ComposeMessage {
  NOT_ALLOWED_VIEW: typeof NOT_ALLOWED_VIEW
  settingsCollapsed: boolean
  SEND_TO: typeof NOTIFICATION_TARGET
  sendTo: string
  users: User[]
  selectedUsers: User[]
  search: string
  loadingUsers: boolean
  domains: Array<Domain | UserDomain>
  selectedDomain: number
  loadingDomains: boolean
  groups: GroupEntity[]
  selectedGroups: GroupEntity[]
  openSelection: boolean
  outOfSearch: boolean
  outOfSelection: boolean
  confirmDomainChange: boolean
  filteredItems: User[] | GroupEntity[]
  loadingGroups: boolean
  subgroups: boolean
  subject: string
  message: string
  sendingMessage: boolean
  messageSended: boolean
}

export { NotificationRequest, NotificationResponse, NOTIFICATION_TARGET, ComposeMessage }
